export default "__VITE_ASSET__5c803dee__"